<template>
  <div class="shou_warpuinfo">
    <el-card style=" height: 100%;">
      <p>工作地点分布情况</p>
      <div class="user" ref="info"></div>
    </el-card>
  </div>
</template>

<script>
import { WeibullDistribution } from "@/network";
export default {
  data() {
    return {};
  },
  created() {},
  mounted() {
    this.getinfoEcharts();
  },
  methods: {
    async getinfoEcharts() {
      const { code, data, msg } = await WeibullDistribution();
      if (code == 200) {
        let getInfo = {
          cnt: [],
          cnt2: [],
          cnt3: [],
          house: [],
          title: [],
        };
        for (const item of data) {
          getInfo.cnt.push(item.cnt);
          getInfo.cnt2.push(item.cnt2);
          getInfo.cnt3.push(item.cnt3);
          getInfo.house.push(item.house);
          let ifno = getInfo.title.indexOf(item.title);
          if (ifno == -1) {
            getInfo.title.push(item.title, item.title2, item.title3);
          }
        }
        this.getInfo(getInfo);
      }
    },
    getInfo(getInfo) {
      let myEcharts = this.$echarts.init(this.$refs.info);
      let symbolImg = "image://" + require("@/assets/img/jiuye.png");
      let symbolImghuodong = "image://" + require("@/assets/img/huodong.png");
      var maxData = 200;

      let option = {
        // title: {
        //   text: "就业人员从事行业占比",
        //   left: "center",
        //   y: "10",
        //   textStyle: {
        //     color: "#999",
        //   },
        // },
        legend: {
          data: getInfo.title,
        },
        // backgroundColor: "#101a3c",
        grid: {
          left: "12%",
          top: "10%",
          bottom: "8%",
        },
        tooltip: {
          trigger: "item",
          textStyle: {
            fontSize: 12,
          },
          formatter: "{b0}:{c0}",
        },
        xAxis: {
          max: 300,
          splitLine: {
            show: false,
          },

          axisLine: {
            show: false,
            lineStyle: {
              color: "#999",
            },
          },
          axisLabel: {
            show: true,
            margin: 10,
          },
          axisTick: {
            show: false,
          },
        },
        yAxis: [
          {
            type: "category",
            inverse: false,
            data: getInfo.house,
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              margin: -4,
              textStyle: {
                // color: "#fff",
                color: "#777885",
                fontSize: 14.25,
              },
            },
          },
        ],
        series: [
          {
            name: getInfo.title[0],
            type: "pictorialBar",
            symbol: symbolImg,
            symbolRepeat: "fixed",
            symbolMargin: "5%",
            symbolClip: true,
            symbolSize: 22.5,
            symbolPosition: "start",
            symbolOffset: [20, 0],
            label: {
              show: true,
              formatter: function(params) {
                return ((params.value / maxData) * 100).toFixed(1) + " %";
              },
              position: "right",
              offset: [10, 0],
              color: "green",
              fontSize: 18,
            },
            symbolBoundingData: 300,
            data: getInfo.cnt,
            z: 10,
          },
          {
            name: getInfo.title[1],
            type: "pictorialBar",
            itemStyle: {
              normal: {
                opacity: 0.3,
              },
            },
            label: {
              normal: {
                show: false,
              },
            },
            animationDuration: 0,
            symbolRepeat: "fixed",
            symbolMargin: "5%",
            symbol:
              "image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAADYElEQVR4nO2dz0sUYRjHP7tIdAmxQ1LdlhCKMohAIsgiyEuHjkUEFQTlpejS/xCCBB06RBGBBKIG4cGyH0qHBKE9eKyFqBQPRQeNCt06vGNY7bq7szPfeZLnAwuzM+/zgw/DDvMu70wOIVveLscJOwycA44A24CfwAfgKXAbeFVvovlC/o/vuVwuTj+x0FWiYdGbgXvA8RrjHgAXgIVaCbMU3SKr1BhtwEtgZx1jTwI7gG7ga5pNNUO+9pBMuEN9klfYD9xMqZdEsCj6AHAiRtxZYFeyrSSHRdGnYsblCD8jJrEoek8TsbsT6yJhLIrelFFsqlgUPZtRbKpYFP2kidjxxLpIGIuiB4AvMeLmgJGEe0kMi6I/AVdjxPVSx91hVlgUDXAXuEaY16jFMnAJeJhqR01iVTTAdeAYUFxjzBRwCLgl6agJrM51rDAO7AP2EmbxthPO8vfAc2Ams84axLpoCGKLrH1mm8eC6KPAGaAL2Fpj7AZgY7T9DfhRY/wc4eflPmH+OjOynI8uEGbpukXlJ4Dz84V8aWWHcj46q4thFzCNTjJRren2UrlLWPM3WYjuAMYIk/tq2oCx9lK5Q11YLboFGARaxXVX0woMtpfK0uuTWvRFoFNcsxKdhF5kqEX3iuuthbQXtehG/gdMG2kvlm/B1xUuWoSLFmFF9CRwg2TnM4pRzskEc8bGiugR4ArhNjkpJqKcJv51sSJ63eOiRbhoES5ahIsW4aJFuGgRLlqEixbhokW4aBEuWoSLFuGiRbhoES5ahIsW4aJFuGgRLlqEWvTHKvs/p1izWu5qvaSCWvTlCvtmgeEUaw5TeUVtpV5SQy16COgBRoHXhMWb3aS7PnAhqjEQ1RwFeuYL+aEUa/5DFmtYHkefOEwQVmcBvKD+FQNvgNN/P+pHiV8MRbhoES5ahIsW4aJFuGgRLlqEixbhokW4aBEuWoSLFuGiRbhoES5ahIsW4aJFuGgRLlqEixbhokVYEx3nudGKXE1jTfS6xUWLcNEiXLQIFy3CRYtw0SJctAgXLcJFi3DRIv430eUq2+axJvp7jePPqmzHySXFmuhHwFKVYzNA/6rv/VR/s9BSlMsM1kTPEN4DPkU4I8vAO6APOAgsrhq7GO3ri8aUo5ipKIep1zv9AtipgOACGIrLAAAAAElFTkSuQmCC",
            symbolSize: 22.5,
            symbolBoundingData: 300,
            symbolPosition: "start",
            symbolOffset: [20, 0],
            data: getInfo.cnt2,
            z: 5,
          },
          {
            name: getInfo.title[2],
            type: "pictorialBar",
            itemStyle: {
              normal: {
                opacity: 0.3,
              },
            },
            label: {
              normal: {
                show: false,
              },
            },
            animationDuration: 0,
            symbolRepeat: "fixed",
            symbolMargin: "5%",
            symbol: symbolImghuodong,
            symbolSize: 22.5,
            symbolBoundingData: 300,
            symbolPosition: "start",
            symbolOffset: [20, 0],
            data: getInfo.cnt3,
            z: 5,
          },
        ],
      };
      myEcharts.setOption(option);
    },
  },
};
</script>

<style lang="less">
.shou_warpuinfo {
  height: 300px;
  margin: 10px 0;
  overflow: hidden;
  .el-card__body {
    height: 100%;
    overflow: hidden;
    .user {
      width: 100%;
      height: 80%;
      overflow: hidden;
    }
  }
}
</style>
